export default from './permissions-provider';



// WEBPACK FOOTER //
// ./app/components/permissions-provider/index.js